import { type FunctionComponent } from "react";
import ViewMap from "@delivery-management/DeliveyMangement/ViewMap.tsx";
import GoogleMapsProvider from "@/react/core/GoogleMapsProvider.tsx";

interface ViewOrderMapProps {
  onClose?: () => void
}

const ViewOrderMap: FunctionComponent<ViewOrderMapProps> = ({ onClose }) => {

  return (
    <div className="w-full h-[90%] bg-white relative">
      <img src="/icon-close-popup-icon--grey@2x.png" className="z-[9] absolute top-2 right-2 w-[22px] h-[22px]" alt=""
           onClick={onClose}/>
      {/*<GoogleMapsProvider>*/}
        <ViewMap isViewOneOrder={true}/>
      {/*</GoogleMapsProvider>*/}
    </div>
  )
}

export default ViewOrderMap;